import { useEffect } from 'react';

export const useWindowInfiniteScroll = onLoad => {
  useEffect(
    () => {
      if (onLoad) {
        const handleScroll = () => {
          const targeElement = document.querySelector('.content_div ');
          const footerElement = document.querySelector('.footer_web--footer');

          const scrollTop = targeElement.scrollTop; // Desplazamiento dentro del contenedor
          const clientHeight = targeElement.clientHeight; // Altura visible del contenedor
          const scrollHeight = targeElement.scrollHeight; // Altura total del contenido

          if (
            scrollTop + clientHeight >=
            scrollHeight - footerElement.clientHeight
          ) {
            onLoad();
          }
        };

        window.addEventListener('scroll', handleScroll, true);

        return () => window.removeEventListener('scroll', handleScroll, true);
      }
    },
    [onLoad],
  );
};
